import React from 'react';

import { Container, Divider, GreyStyledText, Price } from './styled';
import { IPriceAndCalories } from './types';

export const Calories: React.FC<React.PropsWithChildren<{
  children: React.ReactNode;
  hideCalories?: boolean;
}>> = props => {
  if (props.hideCalories) {
    return null;
  }
  return <>{props.children}</>;
};

export const PriceAndCalories: React.FC<React.PropsWithChildren<IPriceAndCalories>> = ({
  caloriesTestId = 'wizard-calories',
  className,
  currentPrice,
  formattedCalories,
  priceTestId = 'wizard-price',
  shouldHideCalories,
}) => {
  const showCurrentPrice = !!currentPrice;
  const showCalories = !shouldHideCalories;
  const showDivider = showCurrentPrice && showCalories;

  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: (false | Element)[]; className: ... Remove this comment to see the full error message
    <Container className={className}>
      {showCurrentPrice && <Price testID={priceTestId}>{currentPrice}</Price>}
      {showCalories && (
        <Calories>
          {showDivider && <Divider>|</Divider>}
          <GreyStyledText testID={caloriesTestId}>{formattedCalories}</GreyStyledText>
        </Calories>
      )}
    </Container>
  );
};

export default PriceAndCalories;
